var site = site || {};

site.direction = site.direction || {};

(function ($) {
  var $header = $('.site-header');
  var modMaxWidth = 1024;
  var modMinWidth = 768;
  var scalables = [];

  function _verticallyCenterSlideAbstract() {
    // Only do this if browser doesn't support the modern, css-based way to
    // vertically center stuff.
    if (Modernizr.csstransforms) {
      return;
    }

    $('.homepage-slide__abstract--default-y-pos').each(function () {
      var h = $(this).height();

      if (h) {
        $(this).height(h);
        $('.homepage-slide__abstract__inner', this).css('marginTop', -(h / 2));
      }
    });
  }

  function _resize() {
    var $modules = $('.homepage-slide');
    var wW = $(window).width();

    // If not between the min/max width parameters for scaling:
    if (wW >= modMaxWidth || wW < modMinWidth) {
      // Reset any styles that were scaled:
      _.each(scalables, function (item) {
        var styles = {};

        _.each(item.props, function (prop) {
          styles[prop] = '';
        });
        item.$el.css(styles);
      });

      _verticallyCenterSlideAbstract();

      return;
    }

    // Otherwise, scale each scalable property:
    _.each(scalables, function (item) {
      item.$el.each(function () {
        var styles = {};
        var $el = $(this);
        var originalValues = $el.data('scalable-original-values');

        _.each(item.props, function (prop) {
          if (_.isObject(originalValues) && !_.isUndefined(originalValues[prop])) {
            styles[prop] = (wW * originalValues[prop]) / modMaxWidth;
          }
        });

        $el.css(styles);
      });
    });

    _verticallyCenterSlideAbstract();
  }

  Drupal.behaviors.hpSlideModuleDebugLayer = {
    attach: function (context) {
      var qs = {};
      var hash;
      // console.log('where\'s the grid?');
      var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
      var qsValues = {
        'small': 1,
        'medium': 1,
        'mediumplus': 1,
        'large': 1
      };

      for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        qs[hash[0]] = hash[1];
      }

      var size = qs['hp_hero_debug'];

      if (!size || _.isUndefined(qsValues[size])) {
        return;
      }

      $('.homepage-slide__slide', context).prepend('<img class="homepage-slide__debug-layer" src="/media/grid_tools/grid-' + size + '.png" />');
    }
  };

  Drupal.behaviors.hpSlideModule = {
    attach: function (context) {
      $('.homepage-slide', context).each(function () {
        var $module = $(this);
        var $slickWrapper = $('.homepage-slide__inner', $module);
        var $slides = $('.homepage-slide__slide', $slickWrapper);
        var $nav = $('.homepage-slide__nav', $module);
        // Store all the elements that need to scale, which properties need to
        // scale, and what their original values were for the _resize function.
        var modScalableElements = [
          {
            $el: $('.homepage-slide__headline', $module),
            props: ['font-size', 'margin-bottom']
          },
          {
            $el: $('.homepage-slide__description', $module),
            props: ['font-size', 'margin-bottom']
          },
          {
            $el: $('.hp_video_slide', $module),
            props: ['height']
          },
          // {
          //   $el: $('.homepage-slide__link', $module),
          //   props: ['font-size']
          // },
          {
            $el: $('.homepage-slide__abstract__inner', $module),
            props: ['padding-top', 'padding-right', 'padding-bottom', 'padding-left']
          }
        ];

        // Store the original values as whatever they currently are now:
        _.each(modScalableElements, function (item, index) {
          // Each property-value pair may be unique per element, so store them
          // on the element itself:
          item.$el.each(function () {
            var $el = $(this);
            var originalValues = $el.data('scalable-original-values') || {};

            _.each(item.props, function (prop, propIndex) {
              var originalValue = $el.css(item.props[propIndex]);

              if (_.isString(originalValue)) {
                originalValue = originalValue.replace('px', '') - 0;
              }

              originalValues[prop] = originalValue;
            });

            $el.data('scalable-original-values', originalValues);
          });
        });

        scalables = scalables.concat(modScalableElements);

        function _setStyles(index) {
          index = index || 0;
          var $slide = $slides.eq(index);

          // It can also control the color of the carousel arrows
          $module.toggleClass('homepage-slide--light-arrows', !!$slide.data('light-arrows'));
        }

        if ($slides.length > 1) {
          // Autoplay class present
          if ($('.js_autoplay_slide').length) {
            $slickWrapper.slick({
              rtl: site.direction.isRTL,
              fade: true,
              autoplay: true,
              autoplaySpeed: 4000,
              pauseOnHover: false,
              prevArrow: $('.slick-prev', $module),
              nextArrow: $('.slick-next', $module),
              onBeforeChange: function (slickSlider, slideIndex, futureSlideIndex) {
                _setStyles(futureSlideIndex);
              },
              onInit: function () {
                _setStyles();
              }
            });
            $('.slick-prev, .slick-next', $module).once('slick-nav-buttons').on('click', function () {
              // Stop autoplay once the user interacts with the carousel
              $slickWrapper.slickPause();
            });
          } else {
            // No Autoplay Class
            $slickWrapper.slick({
              rtl: site.direction.isRTL,
              fade: true,
              autoplay: false,
              prevArrow: $('.slick-prev', $module),
              nextArrow: $('.slick-next', $module),
              onBeforeChange: function (slickSlider, slideIndex, futureSlideIndex) {
                _setStyles(futureSlideIndex);
              },
              onInit: function () {
                _setStyles();
              }
            });

            _resize();
          }
        } else {
          $nav.hide();
        }
      }); // end each
    }
  };

  if (!Modernizr.csstransforms) {
    $(window).on('load', _resize);
  }

  $(window).on('resize-debounced', _resize);

  _resize();
})(jQuery);
